import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';

const generateImgixUrl = (url) => {
  const res = url
    .replace('https://front.travpromobile.com/', 'https://imgtravpromobile.imgix.net/')
    .replace('https://s3.amazonaws.com/developertool/', 'https://imgtravpromobile.imgix.net/');
  const returnValue = `${res}?fit=clip&w=200&h=auto`;
  return returnValue;
};

const ContactViewCard = ({ name, title, telephone, town, mail, imageUrl, other }) => {
  const phone = telephone?.trim() ?? '';
  const showPlusPrefix = phone.length > 0 && phone[0] !== '+';

  return (
    <div className="contact-card">
      <div className="contact-card-content">
        {imageUrl && <img className="headshot" src={generateImgixUrl(imageUrl)} alt={`${name} - ${name}`} />}
        <p className={clsx('global__text--title')}>{name}</p>
        <p className="global__text--subtitle">{title}</p>
        <p>{town && <strong>{town}</strong>}</p>
        {phone && (
          <a href={`tel:${phone}`}>
            <FontAwesomeIcon icon={['fas', 'phone']} />
            {showPlusPrefix && '+'}
            {phone}
          </a>
        )}
        {mail?.emails[0]?.email && mail?.emails[0]?.email !== 'test@travpromobile.com' && (
          <a href={`mailto:${mail.emails[0].email}`}>
            <FontAwesomeIcon icon={['fas', 'envelope']} />
            {mail.emails[0].email}
          </a>
        )}
        <hr />
        {other && (
          <div className="quote">
            {other.split('\n').map((e) => {
              return <p>{e}</p>;
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default ContactViewCard;
